var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"fluid":false}},[_c('page-header',{attrs:{"title":"Crear motivo de cierre","subtitle":"Motivo de cierre","back-to":"/motivosCierreOferta"}}),_c('formulario-motivo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }